'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  overflow: hidden;\n  position: relative;\n'], ['\n  overflow: hidden;\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  width: 100%;\n  height: 100%;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  width: 100%;\n  height: 100%;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _slideTheme = require('./slide-theme');

var _slideTheme2 = _interopRequireDefault(_slideTheme);

var _placeholder = require('./placeholder');

var _placeholder2 = _interopRequireDefault(_placeholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * The `Slide` component represents a real slide
 * instance rendered inside the slideshow.
 * Supports scaling (needed to fit the slide into a
 * specific viewport).
 */

var Slide = function (_React$Component) {
  _inherits(Slide, _React$Component);

  function Slide(props) {
    _classCallCheck(this, Slide);

    var _this = _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).call(this, props));

    _this.handleBackgroundChange = function (background) {
      _this.setState({
        slideBackground: background
      });
    };

    _this.state = {
      slideBackground: null
    };
    return _this;
  }

  _createClass(Slide, [{
    key: 'calculateZoom',
    value: function calculateZoom() {
      var _props = this.props,
          width = _props.width,
          height = _props.height;

      var ft = this.props.fitInto;

      if (!ft) return 1.0;

      var fitAspect = width / height;

      // These magic values help to handle edge cases:
      // when either width or height is not present.
      var aspect = (ft.width || Infinity) / (ft.height || -0);

      if (fitAspect >= aspect) {
        return ft.width / width;
      } else {
        return ft.height / height;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          slide = _props2.slide,
          loaded = _props2.loaded;
      var slideBackground = this.state.slideBackground;


      var zoom = this.calculateZoom();
      var background = this.props.background || this.props.theme.slide.background;

      var layerProps = {
        style: {
          width: width,
          height: height,
          transform: zoom === 1.0 ? 'none' : 'scale(' + zoom + ', ' + zoom + ')',
          transformOrigin: 'top left'
        }
      };

      return _react2.default.createElement(
        Frame,
        {
          className: this.props.className,
          style: {
            width: width * zoom,
            height: height * zoom,
            background: background
          }
        },
        !loaded && _react2.default.createElement(
          Layer,
          null,
          _react2.default.createElement(_placeholder2.default, null)
        ),
        loaded && slideBackground && _react2.default.createElement(
          Layer,
          layerProps,
          slideBackground
        ),
        loaded && _react2.default.createElement(
          Layer,
          layerProps,
          _react2.default.cloneElement(slide.element, {
            onBackgroundChange: this.handleBackgroundChange
          })
        )
      );
    }
  }]);

  return Slide;
}(_react2.default.Component);

Slide.propTypes = {
  // Slide settings
  slide: _propTypes2.default.object.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,

  background: _propTypes2.default.string,
  loaded: _propTypes2.default.bool,
  fitInto: _propTypes2.default.shape({
    width: _propTypes2.default.number,
    height: _propTypes2.default.number
  })
};
Slide.defaultProps = {
  loaded: true
};


var Frame = _styledComponents2.default.div(_templateObject);

var Layer = _styledComponents2.default.div(_templateObject2);

var ConnectedSlide = (0, _styledComponents.withTheme)(Slide);

var SlideOuter = function SlideOuter(props) {
  return _react2.default.createElement(
    _slideTheme2.default,
    null,
    _react2.default.createElement(ConnectedSlide, props)
  );
};

exports.default = SlideOuter;